// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "bootstrap";
import "./application/controllers";
Turbo.session.drive = false;